import React, {Component} from 'react';
import propTypes from 'prop-types';
import {Redirect, Route} from "react-router-dom";

class PrivateRoute extends Component {

    static propTypes = {
        component : propTypes.func.isRequired,
        path : propTypes.string.isRequired
    }

    render() {
        const {component : Component, auth : isAuth ,logout : Logout , ...restProps } = this.props;
        return <Route {...restProps} render={(props) => (
            isAuth ? (
                <Component {...restProps} auth={isAuth} logout={Logout}/>
            ):(
                <Redirect to={{pathname : '/admin_login' , state : {from : props.location}}} />
            )
        )}/>
    }
}

export default PrivateRoute;
